import {LOGIN, LOGOUT, REFRESH} from '../types/index'

const initialState = {
    user: JSON.parse(localStorage.getItem('user')) || {},
    token: localStorage.getItem('token') || '',
    refreshToken: localStorage.getItem('refreshToken') || '',
    isLoggedIn: !!localStorage.getItem('user'),
}

const authReducer = (state = initialState, {type, payload}) => {

    switch (type) {
        case LOGIN:
            return {
                ...state,
                user: payload.user,
                token: payload.token,
                refreshToken: payload.token,
                isLoggedIn: true
            }

        case LOGOUT:
            return {
                ...state,
                user: {},
                token: '',
                refreshToken: '',
                isLoggedIn: false
            }

        case REFRESH:
            return {
                ...state,
                token: payload.token,
            }

        default:
            return state
    }
}

export default authReducer
